module.exports = __webpack_public_path__ + "static/media/logout.3095d592.svg";